import React from "react";

/**
 * Airbnb's save heart, 16px at stroke 2 in `currentColor`; `filled` paints it in too (a
 * saved stay).
 */
const HeartOutlineIcon: React.FC<{ filled?: boolean; className?: string }> = ({
  filled = false,
  className,
}) => (
  <svg
    viewBox="0 0 32 32"
    aria-hidden
    className={className}
    style={{
      display: "block",
      fill: filled ? "currentColor" : "none",
      height: 16,
      width: 16,
      stroke: "currentColor",
      strokeWidth: 2,
      overflow: "visible",
    }}
  >
    <path d="m15.9998 28.6668c7.1667-4.8847 14.3334-10.8844 14.3334-18.1088 0-1.84951-.6993-3.69794-2.0988-5.10877-1.3996-1.4098-3.2332-2.11573-5.0679-2.11573-1.8336 0-3.6683.70593-5.0668 2.11573l-2.0999 2.11677-2.0988-2.11677c-1.3995-1.4098-3.2332-2.11573-5.06783-2.11573-1.83364 0-3.66831.70593-5.06683 2.11573-1.39955 1.41083-2.09984 3.25926-2.09984 5.10877 0 7.2244 7.16667 13.2241 14.3333 18.1088z" />
  </svg>
);

export default HeartOutlineIcon;
